import React from 'react';
import { Link } from 'react-router-dom';
import {BookOpen, Map, Train, CreditCard, Cloud, Backpack} from 'lucide-react';

const guideCategories = [
  {
    title: 'First-Time Visitor Guides',
    slug: '/guides/first-time',
    icon: BookOpen,
    description: 'Essential tips and advice for first-time travelers',
    color: 'bg-[#FF6B35]'
  },
  {
    title: 'Itineraries',
    slug: '/guides/itineraries',
    icon: Map,
    description: 'Curated day-by-day travel plans for popular destinations',
    color: 'bg-[#4A90E2]'
  },
  {
    title: 'Transport Guides',
    slug: '/guides/transport',
    icon: Train,
    description: 'Navigate public transport systems with confidence',
    color: 'bg-[#F7B32B]'
  },
  {
    title: 'Money & SIM Cards',
    slug: '/guides/money-sim',
    icon: CreditCard,
    description: 'Currency exchange, cards, and staying connected',
    color: 'bg-[#FF6B35]'
  },
  {
    title: 'Weather & Seasons',
    slug: '/guides/weather',
    icon: Cloud,
    description: 'Best times to visit and what to expect',
    color: 'bg-[#4A90E2]'
  },
  {
    title: 'Packing & Preparation',
    slug: '/guides/packing',
    icon: Backpack,
    description: 'Smart packing tips and pre-trip preparation',
    color: 'bg-[#F7B32B]'
  }
];

export default function Guides() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-[#0A2540] to-[#1a3a5f] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Travel Guides</h1>
          <p className="text-xl text-gray-200 max-w-3xl">
            Comprehensive guides to help you plan, prepare, and navigate your journey with confidence
          </p>
        </div>
      </div>

      {/* Guide Categories */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {guideCategories.map((category) => {
            const Icon = category.icon;
            return (
              <Link
                key={category.slug}
                to={category.slug}
                className="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-1"
              >
                <div className={`${category.color} p-6 flex items-center justify-center`}>
                  <Icon className="w-16 h-16 text-white" />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-[#0A2540] mb-3 group-hover:text-[#FF6B35] transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-gray-600">{category.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
